

















































import { Component } from "@/shared/vuepack";
import { Validator } from "vee-validate";
import { ErrorsMixin } from "@/employer/components/shared/ErrorsMixin";
import { mixins } from "vue-class-component";
import moment from "moment";
import EmployeesNavigation from "@/employer/components/user-management/EmployeesNavigation.vue";
import { useUserStore } from "@/shared/store/user";
import { useNotifierStore } from "@/shared/store/notifier";
import { useEmployeeInviteDateStore } from "@/employer/store/employeeInviteDate";

@Component({
  components: {
    EmployeesNavigation
  }
})
export default class EmailInviteDate extends mixins(ErrorsMixin) {
  $validator: Validator;

  employeeInviteDateStore = useEmployeeInviteDateStore();
  userStore = useUserStore();
  notifierStore = useNotifierStore();

  isInvalidDate = false;

  mounted (): void {
    this.employeeInviteDateStore.getEarliestInviteDate(this.userStore.employerId).catch(this.handleError);
  }

  get inviteInputString (): string {
    return this.isInvalidDate ? null : this.employeeInviteDateStore.earliestInviteDateLocalString;
  }

  set inviteInputString (localDateString: string) {
    const proposedDate = moment.utc(localDateString);

    this.isInvalidDate = !proposedDate.isValid();

    if (this.isInvalidDate) return;

    this.employeeInviteDateStore.setInviteDate(proposedDate);
  }

  isPageEditable (): boolean {
    return this.employeeInviteDateStore.canEditInviteDate;
  }

  get buttonText () {
    if (this.isSubmitting) {
      return "Saving...";
    }
    if (this.employeeInviteDateStore.hasSeverValueForInviteDate) {
      return "Update";
    }
    return "Schedule";
  }

  get isLoaded () {
    return this.employeeInviteDateStore.isFetchStatusLoaded;
  }

  get inviteEmailSentDate () {
    return moment(this.employeeInviteDateStore.initialEmailSentDate).format("YYYY-MM-DD");
  }

  get initialSend (): boolean {
    return this.employeeInviteDateStore.initialEmailSentDate;
  }

  onSubmit (): void {
    if (this.submitDisabled) {
      return;
    }
    this.$validator.validateAll().then(formPassedValidation => {
      if (formPassedValidation) {
        this.isSubmitting = true;
        this.employeeInviteDateStore.setEarliestInviteDate(this.userStore.employerId).then(success => {
          this.notifierStore.setSuccess("Earliest invite email send date has been saved!");
          this.handleSuccess();
        }).catch(this.handleError);
      }
    });
  }

  handleSuccess () {
    this.isSubmitting = false;
  }

  get submitDisabled () {
    return this.$validator.errors.any() || this.isSubmitting || !this.isPageEditable();
  }
}
